document.addEventListener("DOMContentLoaded", function () {
  const overlay = document.getElementById("opening-animation");
  const welcomeText = overlay.querySelector(".welcome-text");
  const animationOverlay = overlay.querySelector(".animation-overlay");

  // 背景のグラデーションを表示
  setTimeout(() => {
    animationOverlay.classList.add("show");
  }, 200);

  // テキストまたはロゴを表示
  setTimeout(() => {
    welcomeText.classList.add("show");
  }, 800);

  // テキストまたはロゴをフェードアウト
  setTimeout(() => {
    welcomeText.classList.add("hide");
  }, 3500);

  // オーバーレイを非表示
  setTimeout(() => {
    overlay.classList.add("hide");
  }, 4000);

  // 要素を完全に削除
  setTimeout(() => {
    overlay.style.display = "none";
  }, 6500);
});
